import { UserContext } from '@contexts/Shared';
import { useContext, useEffect } from 'react';
import { useAnalyticsTracker } from '../../../services/analytics';

const SegmentPageContainer = ({ children }) => {
  const tracker = useAnalyticsTracker();
  const user = useContext(UserContext);

  useEffect(() => {
    const userData = user?.data;
    if (userData && userData.id) {
      tracker.trackIdentity({
        userId: userData.id.toString(),
        userData: userData,
      });
    }
  }, [tracker, user]);

  useEffect(() => {
    tracker.trackPage();
  }, [tracker]);

  return <>{children}</>;
};

export { SegmentPageContainer };
